import { useState } from 'react'
import { translations } from '../../../../../configs/translations'
import { Language } from '../../../../../context/LanguageContext'
import { arabNumberToRoman } from '../../../../../utils/arabNumberToRoman'
import './ToolTipFullVehicleSpec.css'

export interface ToolTipFullVehicleSpecProps {
	name: string,
	value_sign: string,
	baseValue: string | number
	effects: {
		effectId: string,
		value: string,
		positive: boolean
	}[]
	description: string
}

export const ToolTipFullVehicleSpec = ({ name, baseValue, effects, value_sign, description }: ToolTipFullVehicleSpecProps) => {

	const [language, setLanguage] = useState<Language>('ru')
	const t = translations[language]

	const resolveEffectName = (effectId: string) => {
		if (effectId.startsWith("effect_module")) {
			const effectElements: string[] = effectId.split("_")
			if (effectElements.length > 5) {
				const moduleType = effectElements[3]
				const moduleLevel = parseInt(effectElements[4]) + 1
				return `${t[moduleType.toLowerCase() as keyof typeof t] ?? moduleType} (${arabNumberToRoman(moduleLevel)} ${t.level_short})`
			} else {
				return t.unknown
			}
		} else {
			return t[effectId as keyof typeof t] ?? effectId
		}
	}

	return (<>

		<div className='tooltip-full-vehicle-spec'>
			<p className='tooltip-full-vehicle-spec-description'>{description}</p>
			<div className='tooltip-full-vehicle-spec-basic'>
				<p>{t.basic_value}: {baseValue} {value_sign}</p>
			</div>
			<div className='tooltip-full-vehicle-spec-effects'>
				{effects.map((effect) => (
					<p key={effect.effectId}>
						• {resolveEffectName(effect.effectId)}: <span
							className={`tooltip-full-vehicle-spec-effects-value ${effect.positive ? 'positiv' : 'negativ'}`}
						>
							{effect.value} {value_sign}
						</span>
					</p>
				))}
			</div>
		</div>

	</>)

}